module.exports = __webpack_public_path__ + "static/media/On hold.7f332938.svg";